import isUndefined from 'lodash/isUndefined';

import {
    trackEventFromState,
    trackEventFromStateOnPageUnload,
} from '@eb/site-analytics';

import {
    GA_SIWA_EMAIL_ALREADY_EXISTS,
    GA_HIDDEN_EMAIL,
    GA_SHOWED_EMAIL,
    GA_EMAIL_NOT_FOUND,
    GA_SIWA_ACCOUNTS_LINK_OPTION,
    GA_LINK_ACCOUNT_OPTION,
    GA_SIWA_ACCOUNT_CREATED,
    GA_SIWA_ACCOUNT_CREATED_FAILED,
    GA_TOKEN_EXPIRED,
    GA_SESSION_EXPIRED,
    GA_LOGIN_CATEGORY,
    GA_LOGIN_CLICKED,
    GA_SIGNUP_CLICKED,
    GA_LOGIN_SUCCESSFUL,
    GA_LOGIN_SUCCESSONESTEP,
    GA_PASSWORD_INCORRECT,
    GA_PASSWORD_VIEWED,
    GA_PASSWORD_FORGOTTEN,
    GA_PASSWORD_FORGOTTEN_MAIL_FAILED,
    GA_PASSWORD_FORGOTTEN_MAIL_SENT,
    GA_PASSWORD_RESETED,
    GA_PASSWORD_RESETED_FAILED,
    GA_COMMUNITY_GUIDELINES_CLICKED,
    GA_PRIVACY_POLICY_CLICKED,
    GA_TERMS_OF_SERVICE_CLICKED,
    GA_USE_ANOTHER_ACCOUNT_CLICKED,
    GA_MAGIC_LINK_CLICKED,
    GA_MAGIC_LINK_SENT,
    GA_MAGIC_LINK_FAILED,
    GA_MAGIC_LINK_CONFIRMATION_CLOSED,
    GA_ACCOUNT_LINKED,
    GA_ACCOUNT_LINK_FAILED,
    GA_ACCOUNT_LOGIN_NOT_LINKED,
    GA_ACCOUNT_LINK_CONFIRMATION_CLOSED,
    GA_EVENTBRITE,
    GA_FACEBOOK,
    GA_APPLE,
    GA_SOCIAL_LOGIN_EMAIL_ALREADY_EXISTS,
    GA_SOCIAL_SOFT_ACCOUNT_EXISTS,
    GA_LINK_ACCOUNTS_LOGIN_EVENT,
    GA_SOCIAL_LOGIN_ACCOUNT_LINKING_FAILED,
    GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_FB,
} from '../constants/analytics';

import {
    GA_AUTH_CATEGORY,
    GA_LOGIN_INVALID_PASSWORD,
    GA_APPLE_LOGIN_BUTTON_CLICKED_EVENT,
    GA_FB_LOGIN_BUTTON_CLICKED_EVENT,
    GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB,
    GA_FB_LOGIN_LOGGED_IN_TO_FB,
    GA_COMUNITY_GUIDELINES_CLICKED as OLD_GA_COMUNITY_GUIDELINES_CLICKED,
    GA_PRIVACY_POLICY_CLICKED as OLD_GA_PRIVACY_POLICY_CLICKED,
    GA_TOS_CLICKED as OLD_GA_TOS_CLICKED,
    GA_GET_STARTED_CLICKED,
    GA_FORGOT_PASSWORD_EVENT,
    GA_EDIT_EMAIL_EVENT,
} from '../constants/newIndex';

// Used to capitalize labels once a tracking is triggered
const capitalize = (string) => {
    if (!isUndefined(string)) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
        return string;
    }
};
// SIWA flow metrics

/****************************
 * User doesn't share email *
 ****************************/

// User has an EB account
export const trackSIWA_LookUpSuccessWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_HIDDEN_EMAIL,
    });
};

// User has an EB account, enters wrong password
export const trackSIWA_WrongPassword = (state) => {
    trackEventFromState(state, {
        action: GA_LOGIN_INVALID_PASSWORD,
        category: GA_AUTH_CATEGORY,
        label: capitalize(GA_APPLE),
    });
};

// User doesn't has an EB account, enters an email that isn't an EB account
export const trackSIWA_EmailNotFound = (state) => {
    trackEventFromState(state, {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_EMAIL_NOT_FOUND,
    });
};

// track accounts linked when user hide the email but add EB account on page load
export const trackSIWA_AccountsLinkOptionWithHiddenEmail = (hidden) => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_ACCOUNTS_LINK_OPTION,
        category: GA_AUTH_CATEGORY,
        label: hidden ? GA_HIDDEN_EMAIL : GA_SHOWED_EMAIL,
    });
};

// track account created when user hide his email and doesn't have an EB account
export const trackSIWA_AccountCreatedWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_ACCOUNT_CREATED,
        category: GA_AUTH_CATEGORY,
        label: capitalize(GA_APPLE),
    });
};

// track when user wants to link his account with an EB account
export const trackSIWA_AccountLinkAttemptWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_LINK_ACCOUNT_OPTION,
    });
};

/****************************
 *     User share email     *
 ****************************/

// track successfuly login with showed email
export const trackSIWA_LookUpSuccessWithEmail = () => (dispatch, getState) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_SHOWED_EMAIL,
    });
};

/*
 * User enter wrong password for his EB account
 */
// export const trackSIWA_WrongPasswordWithEBAccount = (sourceProvider) => (
//     dispatch,
//     getState,
// ) => {
//     trackEventFromState(getState(), {
//         action: GA_LOGIN_INVALID_PASSWORD,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

/*
 * User successfuly link their account
 */
// export const trackSIWA_LinkAccountWithEBAccount = (sourceProvider) => (
//     dispatch,
//     getState,
// ) => {
//     trackEventFromState(getState(), {
//         action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

/*
 * User enter an email that isn't an EB account
 */
// export const trackSIWAEmailNotFound = () => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_SIWA_EMAIL_ALREADY_EXISTS,
//         category: GA_AUTH_CATEGORY,
//         label: GA_EMAIL_NOT_FOUND,
//     });
// };

export const trackSIWA_errorOnNewUser = (state, label) => {
    trackEventFromState(state, {
        action: GA_SIWA_ACCOUNT_CREATED_FAILED,
        category: GA_AUTH_CATEGORY,
        label,
    });
};

/****************************
 *     General cases     *
 ****************************/

// Track when token expired
export const trackTokenExpired = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_TOKEN_EXPIRED,
        label:
            !isUndefined(sourceProvider) && sourceProvider !== 'None'
                ? capitalize(sourceProvider)
                : GA_EVENTBRITE,
    });
};

// Track when session has expired
export const trackSessionExpired = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SESSION_EXPIRED,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};
/****************************************
 * *GA TRACKING FOR LOGIN VERSION 2.X.X *
 ****************************************/

export const trackLoginClicked = ({
    sourceProvider,
    stateFromProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    // old flow metrics
    let action = '';

    if (!launchAuthenticationRefactor) {
        if (isUndefined(sourceProvider)) {
            action = GA_GET_STARTED_CLICKED;
        } else if (sourceProvider === GA_EVENTBRITE) {
            action = GA_LOGIN_CLICKED;
        } else if (sourceProvider === GA_FACEBOOK) {
            action = GA_FB_LOGIN_BUTTON_CLICKED_EVENT;

            trackEventFromState(state, {
                category: launchAuthenticationRefactor
                    ? GA_LOGIN_CATEGORY
                    : GA_AUTH_CATEGORY,
                action: action,
                label: capitalize(GA_FACEBOOK),
            });

            if (stateFromProvider && stateFromProvider.status === 'unknown') {
                action = GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB;
            } else {
                action = GA_FB_LOGIN_LOGGED_IN_TO_FB;
            }
        } else if (sourceProvider === GA_APPLE) {
            action = GA_APPLE_LOGIN_BUTTON_CLICKED_EVENT;
        }
    }

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor ? GA_LOGIN_CLICKED : action,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackSignUpClicked = (state) => {
    trackEventFromState(state, {
        category: GA_LOGIN_CATEGORY,
        action: GA_SIGNUP_CLICKED,
    });
};

export const trackLoginSuccessful = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_LOGIN_SUCCESSFUL,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackLoginSuccessOneStep = ({
    sourceProvider,
    state,
    gaCategory,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: !isUndefined(gaCategory)
            ? gaCategory
            : launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_LOGIN_SUCCESSONESTEP,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackPasswordIncorrect = ({
    gaActionCategory,
    sourceProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : gaActionCategory,
        action: launchAuthenticationRefactor
            ? GA_PASSWORD_INCORRECT
            : GA_LOGIN_INVALID_PASSWORD,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackPasswordViewed = ({ sourceProvider, state }) => {
    trackEventFromState(state, {
        category: GA_LOGIN_CATEGORY,
        action: GA_PASSWORD_VIEWED,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackPasswordForgotten = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PASSWORD_FORGOTTEN
            : GA_FORGOT_PASSWORD_EVENT,
        label: capitalize(sourceProvider),
    });
};

export const trackPasswordForgottenMailFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_PASSWORD_FORGOTTEN_MAIL_FAILED,
        label: errorMessage,
    });
};
export const trackPasswordForgottenMailSent = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_PASSWORD_FORGOTTEN_MAIL_SENT,
        label: capitalize(sourceProvider),
    });
};

export const trackPasswordReseted = ({
    sourceProvider,
    state,
    setPasswordEvent,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PASSWORD_RESETED
            : setPasswordEvent,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackPasswordResetedFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_PASSWORD_RESETED_FAILED,
        label: errorMessage,
    });
};

export const trackCommunityGuidelinesClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_COMMUNITY_GUIDELINES_CLICKED
            : OLD_GA_COMUNITY_GUIDELINES_CLICKED,
    });
};

export const trackPrivacyPolicyClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PRIVACY_POLICY_CLICKED
            : OLD_GA_PRIVACY_POLICY_CLICKED,
    });
};

export const trackTermsOfServiceClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_TERMS_OF_SERVICE_CLICKED
            : OLD_GA_TOS_CLICKED,
    });
};

export const trackUseAnotherAccountClicked = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_USE_ANOTHER_ACCOUNT_CLICKED
            : GA_EDIT_EMAIL_EVENT,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackMagicLinkClicked = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_CLICKED,
        label: capitalize(sourceProvider),
    });
};

export const trackMagicLinkSent = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_SENT,
        label: capitalize(sourceProvider),
    });
};

export const trackMagicLinkFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_FAILED,
        label: errorMessage,
    });
};

export const trackMagicLinkConfirmationClosed = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_CONFIRMATION_CLOSED,
        label: capitalize(sourceProvider),
    });
};

export const trackAccountLinked = ({
    sourceProvider,
    state,
    linked = true,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: linked ? GA_ACCOUNT_LINKED : GA_ACCOUNT_LOGIN_NOT_LINKED,
        label: capitalize(sourceProvider),
    });
};

export const trackAccountLinkFailed = ({ errorDescription, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_ACCOUNT_LINK_FAILED,
        label: errorDescription,
    });
};

export const trackAccountLinkConfirmationClosed = ({ label, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_ACCOUNT_LINK_CONFIRMATION_CLOSED,
        label,
    });
};

export const trackSocialEmailAlreadyExists = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SOCIAL_LOGIN_EMAIL_ALREADY_EXISTS,
        label: capitalize(sourceProvider),
    });
};

export const trackSocialSoftAccountExists = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SOCIAL_SOFT_ACCOUNT_EXISTS,
        label: capitalize(sourceProvider),
    });
};

// User has an EB account, successfuly link their account
export const trackSuccessfullyLinkAccountsWithExistingEBAccount = ({
    sourceProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
        label: capitalize(sourceProvider),
    });
};

//Error on linking accounts
export const trackErrorOnLinkAccountsWithExistingEBAccount = ({
    errorDescription,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SOCIAL_LOGIN_ACCOUNT_LINKING_FAILED,
        label: errorDescription,
    });
};

//Account connected with FB without pass
export const trackAccountAlreadyConnectedWithFB = ({
    sourceProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_FB,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};
/** END GA TRACKING FOR LOGIN VERSION 2.X.X */
